import { FunctionalComponent, h, Build } from '@stencil/core';
import get from 'lodash/get'
import { AppMedia, AppLink } from '.'

interface SectionHeaderMobile {
    data?: any;
}

export const SectionHeaderMobile: FunctionalComponent<SectionHeaderMobile> = ({ data }) => {

    const { About, Contact, Logo, Owners, Products, ContactButtons } = data;
    const route = window.location.pathname;

    const getActive = (route, routes) => {
        return routes.includes(route) ? 'uk-active' : ''
    }

    const getLinks = (nav) => {
        const links = (get(nav, 'List1') || []).concat(get(nav, 'List2'), get(nav, 'List3'), get(nav, 'List4'))
            .map((link) => {
                return get(link, 'page.data.attributes.Slug') ? '/' + get(link, 'page.data.attributes.Slug') : get(link, 'URL')
            });
        return links
    }

    const navList = !Build.isBrowser ? <div></div> :  (<ul class="uk-nav uk-nav-default uk-nav-parent-icon" uk-nav>
        <li class='uk-nav-header uk-width-1-1 uk-flex-inline'>
            <div class="uk-width-1-2"></div>
            <div class="uk-width-1-2 uk-text-right uk-offcanvas-close uk-padding-remove-bottom" uk-close></div>
        </li>
        {
            ContactButtons.map((btn) => <li class="uk-text-truncate"><AppLink className="color-primary uk-padding-remove-right uk-heading-small uk-margin-remove-bottom" data={btn} /></li>)
        }
        <li class={`uk-nav-header ${getActive(route, getLinks(Products))}`}>{get(Products, 'Label')}</li>
        <li class="uk-parent">
            <a href="#" rel="nofollow" >{Products.Label1}<span uk-nav-parent-icon></span></a>
            <ul class="uk-nav-sub">
                <li>
                    {
                        (get(Products, 'List1') || []).map((Link, i, a) => {
                            let hyphenGroup = false;
                            if (Link.Label.includes(' - ') && i > 0) {
                                const prior = a[i - 1].Label.split('-')[0];
                                const current = Link.Label.split('-')[0];
                                hyphenGroup = prior == current;
                            }
                            return <li><AppLink className='uk-offcanvas-close uk-text-truncate' data={Link} hyphenGroup={hyphenGroup} /></li>
                        })
                    }
                </li>
            </ul>
        </li>
        <li class="uk-parent">
            <a href="#" rel="nofollow" >{Products.Label2}<span uk-nav-parent-icon></span></a>
            <ul class="uk-nav-sub">
                <li>
                    {
                        (get(Products, 'List2') || []).map((Link, i, a) => {
                            let hyphenGroup = false;
                            if (Link.Label.includes(' - ') && i > 0) {
                                const prior = a[i - 1].Label.split('-')[0];
                                const current = Link.Label.split('-')[0];
                                hyphenGroup = prior == current;
                            }
                            return <li><AppLink className='uk-offcanvas-close uk-text-truncate' data={Link} hyphenGroup={hyphenGroup} /></li>
                        })
                    }
                </li>
            </ul>
        </li>
        <li class="uk-parent">
            <a href="#" rel="nofollow" >{Products.Label3}<span uk-nav-parent-icon></span></a>
            <ul class="uk-nav-sub">
                <li>
                    {
                        (get(Products, 'List3') || []).map((Link, i, a) => {
                            let hyphenGroup = false;
                            if (Link.Label.includes(' - ') && i > 0) {
                                const prior = a[i - 1].Label.split('-')[0];
                                const current = Link.Label.split('-')[0];
                                hyphenGroup = prior == current;
                            }
                            return <li><AppLink className='uk-offcanvas-close uk-text-truncate' data={Link} hyphenGroup={hyphenGroup} /></li>
                        })
                    }
                </li>
            </ul>
        </li>


        <li class={`uk-nav-header ${getActive(route, getLinks(Owners))}`}>{get(Owners, 'Label')}</li>
        <li class="uk-parent">
            <a href="#" rel="nofollow" >{Owners.Label1}<span uk-nav-parent-icon></span></a>
            <ul class="uk-nav-sub">
                <li>
                    {
                        (get(Owners, 'List1') || []).map((Link) => (get(Link, 'Label') || get(Link, 'Icon')) ? <li><AppLink className='uk-offcanvas-close uk-text-truncate' data={Link} /></li> : <li class="uk-margin-small-top"></li>)
                    }
                </li>
            </ul>
        </li>
        <li hidden={!Owners.Label2} class="uk-parent">
            <a href="#" rel="nofollow" >{Owners.Label2}<span uk-nav-parent-icon></span></a>
            <ul class="uk-nav-sub">
                <li>
                    {
                        (get(Owners, 'List2') || []).map((Link) => (get(Link, 'Label') || get(Link, 'Icon')) ? <li><AppLink className='uk-offcanvas-close uk-text-truncate' data={Link} /></li> : <li class="uk-margin-small-top"></li>)
                    }
                </li>
            </ul>
        </li>


        <li class={`uk-nav-header ${getActive(route, getLinks(About))}`}>{get(About, 'Label')}</li>
        <li class="uk-parent">
            <a href="#" rel="nofollow" >{About.Label1}<span uk-nav-parent-icon></span></a>
            <ul class="uk-nav-sub">
                <li>
                    {
                        (get(About, 'List1') || []).map((Link) => <li><AppLink className='uk-offcanvas-close uk-text-truncate' data={Link} /></li>)
                    }
                </li>
            </ul>
        </li>
        <li class="uk-parent">
            <a href="#" rel="nofollow" >{About.Label2}<span uk-nav-parent-icon></span></a>
            <ul class="uk-nav-sub">
                <li>
                    {
                        (get(About, 'List2') || []).map((Link) => <li><AppLink className='uk-offcanvas-close uk-text-truncate' data={Link} /></li>)
                    }
                </li>
            </ul>
        </li>
        <li class="uk-parent">
            <a href="#" rel="nofollow" >{About.Label3}<span uk-nav-parent-icon></span></a>
            <ul class="uk-nav-sub">
                <li>
                    {
                        (get(About, 'List3') || []).map((Link) => <li><AppLink className='uk-offcanvas-close uk-text-truncate' data={Link} /></li>)
                    }
                </li>
            </ul>
        </li>
        <li class="uk-parent">
            <a href="#" rel="nofollow" >{About.Label4}<span uk-nav-parent-icon></span></a>
            <ul class="uk-nav-sub">
                <li>
                    {
                        (get(About, 'List4') || []).map((Link) => <li><AppLink className='uk-offcanvas-close uk-text-truncate' data={Link} /></li>)
                    }
                </li>
            </ul>
        </li>
        <li class={`uk-nav-header ${getActive(route, ['/contact'])}`}>
            <AppLink className="uk-nav-header uk-offcanvas-close" data={{ URL: '/contact', Label: get(Contact, 'Label') }} />
        </li>
    </ul>)

    return (
        <div class="uk-hidden@s">
            <div class="uk-background-primary-striped uk-position-relative">
                <div class="uk-container uk-container-xlarge uk-light uk-padding-small">
                </div>
            </div>
            <header class="uk-position-z-index uk-background-white uk-background-glass wsio-header" uk-sticky="show-on-up: true; animation: uk-animation-slide-top; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky">
                <div class="uk-position-relative">
                    <div class="uk-container uk-padding">
                        <div class="uk-flex">
                            <div class="uk-flex uk-flex-middle uk-position-relative">
                                <a href="/">
                                    <AppMedia media={Logo} className='uk-width-small uk-position-z-index uk-margin-large-right' />
                                </a>
                            </div>
                            <div class="uk-flex-1">
                            </div>
                            <div class="uk-flex uk-flex-middle uk-position-relative">
                                <a href="#offcanvas-slide" class="uk-flex-1 uk-button uk-button-link uk-flex uk-flex-middle uk-heading-small" uk-toggle><span class="uk-margin-small-right uk-icon" uk-icon="menu"></span>Menu</a>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div id="offcanvas-slide" uk-offcanvas="flip: true">
                <div class="uk-offcanvas-bar uk-background-primary-striped">
                    {navList}
                </div>
            </div>
        </div>
    )
};


